export const DEFAULT_AUTHENTICATED_PATH = "/order-list";
export const DEFAULT_UNAUTHENTICATED_PATH =
  "/order-unauthenticated-accept-terms";
export const LOGIN_AS_REGISTERED_PATH = "/login-as-registered";
